export type SidebarMode = 'drawer' | 'compact' | 'wide';

export interface ISidebarModeInput {
    /** Страница с телефонной раскладкой на узком экране: меню живёт в Drawer. */
    mobile: boolean;
    /** Окно уже минимального десктопа: закрепление недоступно, только рейл и временная панель. */
    compact: boolean;
    /** Сохранённое предпочтение пользователя (`<storageKey>.pinned`). */
    pinnedPreference: boolean;
    overlayOpen: boolean;
    mobileMenuOpen: boolean;
}

export interface ISidebarState {
    mode: SidebarMode;
    /** Панель занимает место в раскладке. */
    pinned: boolean;
    /** Полное меню видно (закреплено, временная панель или Drawer). */
    open: boolean;
}

/** Ширина окна — свойство среды, а не предпочтение: в compact предпочтение не перезаписывается,
 *  а лишь не действует, поэтому при расширении окна закреплённое меню возвращается само. */
export function resolveSidebar({
    mobile,
    compact,
    pinnedPreference,
    overlayOpen,
    mobileMenuOpen,
}: ISidebarModeInput): ISidebarState {
    if (mobile) return { mode: 'drawer', pinned: false, open: mobileMenuOpen };
    const pinned = pinnedPreference && !compact;
    return { mode: compact ? 'compact' : 'wide', pinned, open: pinned || overlayOpen };
}
